export enum BookingStatus {
  ACCEPTED = 'ACCEPTED',
  CANCELLED = 'CANCELLED',
  NO_SHOW = 'NO_SHOW',
}

export enum BookingTimeframe {
  UPCOMING = 'UPCOMING',
  PREVIOUS = 'PREVIOUS',
}
